import { api } from "@/lib/api-client";
import type { WalletBalance, WalletHistoryEntry, TopupResponse } from "@/types/wallet";

export const walletService = {
  getBalance: (token?: string) =>
    api.get<WalletBalance>("/wallet/balance", { token }),

  topup: (amount: number, token?: string) =>
    api.post<TopupResponse>("/wallet/topup", { amount }, { token }),

  getHistory: (page: number, limit: number, token?: string) =>
    api.get<WalletHistoryEntry[]>(
      `/wallet/history?page=${page}&limit=${limit}`,
      { token }
    ),
};
